<div class="basicrow m-top">
        <div class="autowcont m-bott">
            <div class="basicrow msidespad">
                <div class="b-title">
                    <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                        <div class="tabcell" *ngIf="this.typeOfAction=='add'">
                            Asignaci&oacute;n de Permisos
                        </div>
                        <div class="tabcell" *ngIf="this.typeOfAction=='edit'">
                            Actualizar Permisos del Usuario
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="basicrow text-center m-top-u msidespad">
                <div class="userallinfo f-black m-info-mob">
                    <div class="phn-nmbr p-top-a">
                        <div class="basicrow">
                            <img width="100%" class="phn-icon" src="../../../assets/images/phn-icon.png">
                        </div>
    
                        <div class="basicrow m-top-u">
                            <span class="roboto-b">
                                N&uacute;mero de tel&eacute;fono
                            </span><br/>
    
                            <span class=" f-btitle-i roboto-l">{{this.phoneNumber}}</span>
                        </div>
                    </div>
    
                    <div class="userinfo m-info-mob">
                        <div class="redstat">
                            <div class="autorow roboto-r pull-left">
                                Rol
                            </div>
    
                            <div class="autorow roboto-b pull-right" style="text-transform: uppercase;">
                                {{this.role}}
                            </div>
                        </div>
                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Nombre
                            </div>
    
                            <div class="autorow roboto-b pull-right">
                                {{this.name}}
                            </div>
                        </div>
    
                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Apellido
                            </div>
    
                            <div class="autorow roboto-b pull-right">
                                    {{this.lastName}}
                            </div>
                        </div>
    
                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Usuario
                            </div>
    
                            <div class="autorow roboto-b pull-right">
                                    {{this.phoneNumber}}
                            </div>
                        </div>
    
                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Correo electr&oacute;nico
                            </div>
    
                            <div class="autorow roboto-b pull-right">
                                    {{this.email}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="basicrow m-top m-bott msidespad">
                <div class="basicrow topbord">
                    <div class="basicrow f-reg f-black m-top-u-i">
                        <div class="basicrow text-justify">
                            <span class="roboto-b f-med">Permisos</span><br/>
                            Con esta función, los usuarios podrán ingresar a la aplicación, tendrán acceso a las secciones que el dueño de la cuenta le otorgue y todas las  funciones bajo los módulos,
                        </div>
    
                        <div class="boxtbl m-top">
                            <div class="tab-tbar">
                                <div class="frwds permit-i rline vcenter">
                                    <div class="tabcell">
                                        Tipo de Permiso
                                    </div>
                                </div>
    
                                <div class="frwds permit-ii vcenter">
                                    <div class="tabcell">
                                        Estatus
                                    </div>
                                </div>
                            </div>
    
                         
                            <div class="permit">
                                <div class="tab-cbar w-mob-a" *ngFor="let module of this.moduleData; let i = index"  [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                                    <div class="frwds permit-i rline vcenter mob-h-a">
                                        <div class="tabcell">
                                            <span class="roboto-b"  [ngClass]="{'m-child': module.id_parent!=module.id_modulo,'': module.id_parent==module.id_modulo}">{{module.Modulo}}</span> <span class="m-desc-a">: {{module.description}}</span>
                                        </div>
                                    </div>
    
                                    <div class="frwds permit-ii vcenter">
                                        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 left-switch-a">
                                        <label class="switch dig-def-i m-switch-a">
                                            <input type="checkbox" *ngIf="module.status==true" checked (click)="this.updCheck(i,!module.status);">
                                            <input type="checkbox" *ngIf="module.status!=true" (click)="this.updCheck(i,!module.status);">
                                            <span class="slider" ></span>
                                        </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="basicrow m-top m-bott msidespad">
                    <div class="basicrow topbord">
                        <div class="basicrow f-reg f-black m-top-u-i">
                            <div class="basicrow text-justify">
                                <span class="roboto-b f-med">Permisos</span><br/>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </div>
        
                            <div class="boxtbl m-top">
                                <div class="tab-tbar">
                                    <div class="frwds permit-i rline vcenter">
                                        <div class="tabcell">
                                            Tipo de Permiso
                                        </div>
                                    </div>
        
                                    <div class="frwds permit-ii vcenter">
                                        <div class="tabcell">
                                            Estatus
                                        </div>
                                    </div>
                                </div>
        
                                <div class="permit">
                                    <div class="tab-cbar w-mob-a" *ngFor="let module of this.moduleData; let i = index"  [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                                        <div class="frwds permit-i rline vcenter mob-h-a">
                                            <div class="tabcell">
                                                <span class="roboto-b">{{module.name}}</span> <span class="m-desc-a">: {{module.description}}</span>
                                            </div>
                                        </div>
        
                                        <div class="frwds permit-ii vcenter">
                                            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 left-switch-a">
                                            <label class="switch dig-def-i m-switch-a">
                                                <input type="checkbox" *ngIf="module.status=='True'" checked>
                                                <input type="checkbox" *ngIf="module.status!='True'">
                                                <span class="slider" ></span>
                                            </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div> -->
            <div class="basicrow m-bott msidespad">
                <div class="basicrow topbord">
                    <div class="basicrow m-top-u-i">
                        <a  class="btns def-i red pull-right vcenter" (click)="this.continue()">
                            <span class="tabcell">
                                Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
    
                        <a class="btns def-i gray pull-left vcenter"  (click)="this.back()">
                            <span class="tabcell">
                                Cancelar
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    